<template>
  <tr :class="'border-b border-gray-300 ' + (index % 2 == 0 ? 'bg-gray-100' : 'bg-white')">
    <td class="py-4 pl-6 pr-4 border-r">{{ feedbackItem.date }}</td>
    <td class="p-4 border-r">{{ feedbackItem.user_type }}</td>
    <td class="p-4 border-r">
      <router-link
       :to="{
         name : 'broker-account',
           params : {
             brokerId : feedbackItem.broker_id
           }
       }"
       tag="a"
       class="text-blue-600 no-underline hover:underline">{{ feedbackItem.broker_first_name }} {{ feedbackItem.broker_last_name }}
      </router-link>
    </td>
    <td class="p-4 border-r">{{ feedbackItem.client_first_name }} {{ feedbackItem.client_last_name }}</td>
    <td class="p-4 border-r" style="white-space:pre-wrap;">{{ feedbackItem.message }}</td>
  </tr>
</template>

<script>

  export default {

    props : {
      feedbackItem : {
        type    : Object,
        required: true
      },

      index : {
        type    : Number,
        required: true
      }
    }

  }
</script>
